import React from "react";
import styled from "styled-components";

import Resource from "./Resource";

const resources = [
  {
    title: "Some kickass title",
    matchPercentage: 93,
    reviews: 1234,
    numberOfStars: 2,
    id: "1234",
  },
  {
    title: "Some kickass title",
    matchPercentage: 93,
    reviews: 1234,
    numberOfStars: 2,
    id: "1234",
  },
  {
    title: "Some kickass title",
    matchPercentage: 93,
    reviews: 1234,
    numberOfStars: 2,
    id: "1234",
  },
];

const MoreRecommendationsLink = styled.a`
  color: ${(props) => props.theme.color.darkBlue};
`;
const SectionLocker = styled.section`
  padding: 10rem 0 9rem;
  .locker-front {
    margin-bottom: 6rem;
  }
  
  .locker-front:before,
  .locker-front:after {
    display: table;
    content: ' ';
  }
  
  .locker-front:after {
    clear: both;
  }
  
  .locker-front .locker-left,
  .locker-front .locker-right {
    float: left;
    width: 50%;
  }
  
  .locker-front .locker-right .btn-recommendations {
    margin-top: 3px;
    float: right;
  }
  
  .locker-front .locker-col {
    float: left;
    width: 33.3333333%;
    text-align: center;
  }
  
  .locker-front .locker-col:nth-child(1) {
    padding-right: 10px;
  }
  
  .locker-front .locker-col:nth-child(3) {
    padding-left: 10px;
  }
  
  .locker-front .main-title,
  .locker-front .locker-tabs,
  .locker-front .visual-learner {
    display: inline-block;
  }
  
  .locker-front .main-title {
    float: left;
  }
  
  .locker-front .visual-learner {
    float: right;
  }
  
  .locker-tabs .nav-tabs>li {
    margin-bottom: 0;
  }
  
  .locker-tabs .nav-tabs>li>a {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    position: relative;
    color: #96bffa;
    margin-right: 0;
    padding: 0 18px 11px;
    border: 0;
    font-size: 1.6rem;
  }
  
  .locker-tabs .nav-tabs>li>a:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 1px;
    width: 100%;
    background-color: #ebf3fe;
  }
  
  .locker-tabs .nav-tabs>li>a:hover,
  .locker-tabs .nav-tabs>li>a:focus {
    border: 0;
    color: #0065f2;
    background-color: transparent;
  }
  
  .locker-tabs .nav-tabs>li>a:hover:after,
  .locker-tabs .nav-tabs>li>a:focus:after {
    display: block;
  }
  
  .locker-tabs .nav-tabs>li.active>a {
    color: #0065f2;
  }
  
  .locker-tabs .nav-tabs>li.active>a:after {
    display: block;
    background-color: #0065f2;
  }
  
  .locker-tabs .nav-tabs>li.active>a:hover,
  .locker-tabs .nav-tabs>li.active>a:focus {
    border: 0;
    background-color: transparent;
  }
`;

const ResourcesSection = () => (
  <SectionLocker>
    <div className='container'>
      <div className='locker-front'>
        <div className='locker-left'>
          <div className='main-title'>
            <h2>Recommended Resources</h2>
          </div>
        </div>
        <div className='locker-right'>
          <div className='visual-learner'>
            <MoreRecommendationsLink className='btn-recommendations'>
              More Recommendations
            </MoreRecommendationsLink>
          </div>
        </div>
      </div>
      <div className='locker-panel'>
        <div className='locker-category'>
          <ul className='locker-list'>
            {resources.map((rsrc) => (
              <Resource key={rsrc.id} {...rsrc} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  </SectionLocker>
);

export default ResourcesSection;
